/* ==========================================================================
   Fitfarm Kysy koutsilta, modal-komponentti
   ========================================================================== */
(function () {
  'use strict';

  var dataEl = document.getElementById('ff-kysy-data');
  if (!dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); }
  catch (e) { console.error('ff-kysy: failed to parse data', e); return; }

  var modal = document.getElementById('ff-kysy-modal');
  var content = document.getElementById('ff-kysy-modal-content');
  if (!modal || !content) return;

  // PORTAL: siirrä modal body-tasolle jotta mikään section ei voi peittää sitä
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  var lastFocused = null;

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function renderTag(tag) {
    return '<li>' + escapeHtml(tag) + '</li>';
  }

  function renderCoachView(coachKey) {
    var coach = data.coaches[coachKey];
    if (!coach) return '';

    var tipKeys = (data.coach_tips[coachKey] || []);
    var tips = tipKeys.map(function (k) { return Object.assign({ _key: k }, data.tips[k]); });

    var avatar = coach.photo
      ? '<img src="' + escapeHtml(coach.photo) + '" alt="' + escapeHtml(coach.name) + '" width="96" height="96">'
      : '<span>' + escapeHtml(coach.initial || '') + '</span>';

    var tagsHtml = (coach.tags && coach.tags.length)
      ? '<ul class="ff-kysy__modal-tags">' + coach.tags.map(renderTag).join('') + '</ul>'
      : '';

    var tipsHtml = '';
    if (tips.length) {
      tipsHtml = '<section class="ff-kysy__modal-tips">' +
        '<h3 class="ff-kysy__modal-section-head">Vinkit ' + coach.name + 'lta</h3>' +
        '<ol class="ff-kysy__modal-tip-list">' +
        tips.map(function (tip) {
          return '<li>' +
            '<button type="button" class="ff-kysy__modal-tip-btn" data-open-tip="' + escapeHtml(tip._key) + '">' +
            '<span class="ff-kysy__modal-tip-date">' + escapeHtml(tip.published_at || '') + '</span>' +
            '<span class="ff-kysy__modal-tip-title">' + escapeHtml(tip.heading) + '</span>' +
            '<span class="ff-kysy__modal-tip-arrow" aria-hidden="true">→</span>' +
            '</button></li>';
        }).join('') +
        '</ol></section>';
    } else {
      tipsHtml = '<p class="ff-kysy__modal-empty">' + escapeHtml(coach.name) + ' ei ole vielä julkaissut vinkkejä. Ensimmäinen tulee pian.</p>';
    }

    var sigHtml = coach.signature
      ? '<div class="ff-kysy__modal-signature">' + coach.signature + '</div>'
      : '';

    var bioHtml = coach.bio
      ? '<div class="ff-kysy__modal-bio">' + coach.bio + '</div>'
      : '';

    return '<article class="ff-kysy__modal-coach">' +
      '<header class="ff-kysy__modal-coach-head">' +
        '<div class="ff-kysy__modal-coach-avatar">' + avatar + '</div>' +
        '<div class="ff-kysy__modal-coach-id">' +
          '<h2 id="ff-kysy-modal-title" class="ff-kysy__modal-coach-name">' + escapeHtml(coach.name) + '</h2>' +
          tagsHtml +
        '</div>' +
      '</header>' +
      bioHtml +
      sigHtml +
      tipsHtml +
    '</article>';
  }

  function renderTipView(tipKey) {
    var tip = data.tips[tipKey];
    if (!tip) return '';

    var coach = tip.coach ? data.coaches[tip.coach] : null;
    var coachHtml = '';
    if (coach) {
      var avatar = coach.photo
        ? '<img src="' + escapeHtml(coach.photo) + '" alt="' + escapeHtml(coach.name) + '" width="40" height="40">'
        : '<span>' + escapeHtml(coach.initial || '') + '</span>';
      coachHtml = '<button type="button" class="ff-kysy__modal-tip-author" data-open-coach="' + escapeHtml(tip.coach) + '">' +
        '<span class="ff-kysy__modal-tip-author-avatar">' + avatar + '</span>' +
        '<span class="ff-kysy__modal-tip-author-label">Tutustu <strong>' + escapeHtml(coach.name) + '</strong> <span aria-hidden="true">→</span></span>' +
        '</button>';
    }

    var metaHtml = '';

    return '<article class="ff-kysy__modal-tip">' +
    '<div class="ff-kysy__modal-tip-eyebrow">' +
    (coach ? escapeHtml(coach.name) : '') +
    '</div>' +
      '<h2 id="ff-kysy-modal-title" class="ff-kysy__modal-tip-title-big">' + escapeHtml(tip.heading) + '</h2>' +
      '<div class="ff-kysy__modal-tip-body">' + (tip.body || '') + '</div>' +
      metaHtml +
      coachHtml +
    '</article>';
  }

  function open(html) {
    content.innerHTML = html;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.documentElement.classList.add('ff-kysy-modal-open');
    document.body.classList.add('ff-kysy-modal-open');
    lastFocused = document.activeElement;
    var firstFocus = modal.querySelector('.ff-kysy__modal-close');
    if (firstFocus) firstFocus.focus();
    // scroll to top of content
    var scroll = modal.querySelector('.ff-kysy__modal-scroll');
    if (scroll) scroll.scrollTop = 0;
  }

  function close() {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('ff-kysy-modal-open');
    document.body.classList.remove('ff-kysy-modal-open');
    content.innerHTML = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus(); } catch (e) {}
    }
  }

  function openCoach(key, pushState) {
    var html = renderCoachView(key);
    if (!html) return;
    open(html);
    if (pushState !== false) {
      try { history.replaceState(null, '', '#valmentaja-' + key); } catch (e) {}
    }
  }

  function openTip(key, pushState) {
    var html = renderTipView(key);
    if (!html) return;
    open(html);
    if (pushState !== false) {
      try { history.replaceState(null, '', '#vinkki-' + key); } catch (e) {}
    }
  }

  // Delegated event handling: kaikki [data-open-coach] ja [data-open-tip] klikit
  document.addEventListener('click', function (e) {
    var coachTrigger = e.target.closest('[data-open-coach]');
    if (coachTrigger) {
      e.preventDefault();
      openCoach(coachTrigger.getAttribute('data-open-coach'));
      return;
    }
    var tipTrigger = e.target.closest('[data-open-tip]');
    if (tipTrigger) {
      e.preventDefault();
      openTip(tipTrigger.getAttribute('data-open-tip'));
      return;
    }
    if (e.target.closest('[data-close-modal]')) {
      e.preventDefault();
      close();
    }
  });

  // Esc sulkee
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });

  // Alkuperäinen avaus URL-hashilla
  function openFromHash() {
    var h = (location.hash || '').substring(1);
    if (!h) return;
    if (h.indexOf('valmentaja-') === 0) {
      var ck = h.substring('valmentaja-'.length);
      if (data.coaches[ck]) openCoach(ck, false);
    } else if (h.indexOf('vinkki-') === 0) {
      var tk = h.substring('vinkki-'.length);
      if (data.tips[tk]) openTip(tk, false);
    }
  }
  openFromHash();
  window.addEventListener('hashchange', openFromHash);

})();
